import React from 'react'
import { blackcanyon } from '../../assets'
import { navLinks } from '../../constants'

function Navbar() {

  return (
    <nav className="navbar navbar-expand-lg py-2 shadow-sm bg-light">
    <div className="container">
      <a className="navbar-brand m-0 me-md-3 nav-logo" href="#home"><img src={blackcanyon} alt="logo"/></a>
        <div className="d-flex flex-column">
          <h4 className='nav-title'>Black Canyon Transport</h4>
          <h6 className='nav-title2'>CV. Enam Satu Rentalindo</h6>
        </div>
      
      <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span className="navbar-toggler-icon"></span>
      </button>

      <div className="collapse navbar-collapse justify-content-end" id="navbarSupportedContent">
        <ul className="navbar-nav my-3 my-lg-0 align-items-start align-items-lg-center">
          {navLinks.map(nav => {
            return(
              <li className="nav-item" key={nav.id}>
                <a className="nav-link nav-link-ltr text-dark fw-bold ms-3 w-100" aria-current="page" href={`#${nav.id}`}>
                  {nav.title}
                </a>
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  </nav>
  )
}

export default Navbar